/* eslint-disable import/no-extraneous-dependencies */
// TODO: перевести индексы модулей на ts, чтобы не было ошибок
import core from '@gqlapp/core-client-react';
import look from '@gqlapp/look-client-react';
import i18n from '@gqlapp/i18n-client-react';
import validation from '@gqlapp/validation-common-react';
import ClientModule from '@gqlapp/module-client-react';
import defaultRouter from '@gqlapp/router-client-react';
import authentication from '@gqlapp/authentication-client-react';

import notifications from '@ally/notifications-client-react';
import notificationCenter from '@gqlapp/notification-center-client-react';
import news from '@ally/news-client-react';
import knowledges from '@ally/knowledges-client-react';
import checklists from '@ally/checklists-client-react/index.web';
import userflow from '@ally/userflow-client-react/index.web';
import comments from '@gqlapp/comments-client-react';
import restaurant from '@ally/restaurant-client-react';
import calendar from '@ally/calendar-client-react';
import reports from '@ally/reports-client-react';
import home from '@ally/home-client-react';
import flexModal from '@ally/flex-modal-client-react';
import analytics from '@gqlapp/analytics-client-react';
import pushNotifications from '@ally/push-notifications-client-react';
import toastWarning from '@ally/toast-warning-client-react';

const post = require('@gqlapp/post-client-react').default;
const pageNotFound = require('@gqlapp/page-not-found-client-react').default;
const upload = require('@gqlapp/upload-client-react').default;
const user = require('@gqlapp/user-client-react').default;

const modules = new ClientModule(
  analytics,
  home,
  notifications,
  notificationCenter,
  news,
  knowledges,
  checklists,
  userflow,
  reports,
  restaurant,
  look,
  validation,
  defaultRouter,
  post,
  comments,
  upload,
  calendar,
  user,
  flexModal,
  i18n,
  pageNotFound,
  core,
  authentication,
  pushNotifications,
  toastWarning
);

export default modules;
